import React, { useState } from "react";

export function SubstituteSelect({ id, value, onChange, candidates }) {
  return (
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className="vs-select">
      <option value="">— выбрать —</option>
      {candidates.map((emp) => (
        <option key={emp.id} value={emp.id}>{emp.full_name}</option>
      ))}
    </select>
  );
}

export default function SubstitutionFormRow({
  colSpan,
  idPrefix,
  candidates,
  getWarning,
  initial,
  onSubmit,
  onCancel,
  submitLabel,
  error,
  busy,
}) {
  const [substituteId, setSubstituteId] = useState(
    initial.substitute_employee_id ? String(initial.substitute_employee_id) : ""
  );
  const [start, setStart] = useState(initial.start_date || "");
  const [end, setEnd] = useState(initial.end_date || "");
  const [comment, setComment] = useState(initial.comment || "");
  const warning = getWarning(substituteId, start, end);
  const canSubmit = Boolean(substituteId && start && end) && !busy;

  return (
    <tr className="vs-form-row">
      <td colSpan={colSpan}>
        <form
          className="vs-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (!canSubmit) return;
            onSubmit({
              substitute_employee_id: Number(substituteId),
              start_date: start,
              end_date: end,
              comment,
            });
          }}
        >
          <div className="vs-form__grid">
            <div className="vs-form__field">
              <label htmlFor={`${idPrefix}-sub`} className="vs-label">Замещающий</label>
              <SubstituteSelect
                id={`${idPrefix}-sub`}
                value={substituteId}
                onChange={setSubstituteId}
                candidates={candidates}
              />
            </div>
            <div className="vs-form__field">
              <label htmlFor={`${idPrefix}-start`} className="vs-label">С</label>
              <input
                id={`${idPrefix}-start`}
                type="date"
                value={start}
                onChange={(e) => setStart(e.target.value)}
                className="form-input vs-date"
              />
            </div>
            <div className="vs-form__field">
              <label htmlFor={`${idPrefix}-end`} className="vs-label">По</label>
              <input
                id={`${idPrefix}-end`}
                type="date"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
                className="form-input vs-date"
              />
            </div>
            <div className="vs-form__field">
              <label htmlFor={`${idPrefix}-comment`} className="vs-label">Комментарий</label>
              <input
                id={`${idPrefix}-comment`}
                type="text"
                maxLength={500}
                placeholder="необязательно"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="form-input vs-comment"
              />
            </div>
            <div className="vs-form__actions">
              <button type="submit" className="btn btn-primary" disabled={!canSubmit}>
                {submitLabel}
              </button>
              {onCancel && (
                <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
                  Отмена
                </button>
              )}
            </div>
          </div>
          {warning && <div className="vs-warning">{warning}</div>}
          {error && <div className="vs-error">{error}</div>}
        </form>
      </td>
    </tr>
  );
}
